var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.11 23.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b5580;\n      }\n\n      .cls-2 {\n        fill: #63ecdb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.56,
    cy: 11.56,
    r: 11.56,
    transform: "translate(-1.7 21.11) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.14,7.18c-.44,0-.79,.36-.79,.79s.36,.79,.79,.79,.79-.36,.79-.79-.36-.79-.79-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.61,8.2c-1.84,0-3.34,1.5-3.34,3.34s1.5,3.34,3.34,3.34,3.34-1.5,3.34-3.34-1.5-3.34-3.34-3.34Zm0,5.47c-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14,2.14,.96,2.14,2.14-.96,2.14-2.14,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.26,18.31h-5.41c-2.24,0-4.07-1.83-4.07-4.07v-5.41c0-2.24,1.83-4.07,4.07-4.07h5.41c2.24,0,4.07,1.83,4.07,4.07v5.41c0,2.24-1.83,4.07-4.07,4.07ZM8.85,6.04c-1.54,0-2.8,1.25-2.8,2.8v5.41c0,1.54,1.25,2.8,2.8,2.8h5.41c1.54,0,2.8-1.25,2.8-2.8v-5.41c0-1.54-1.25-2.8-2.8-2.8h-5.41Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9e15296562f5964ebed9d3affbc96f2f.svg";
export { ForwardRef as ReactComponent };